import { makeObservable, observable, action } from 'mobx';
import SettingsRequests from 'Utils/Requests/SettingsRequests';
import React from 'react';
import { ShowAlert } from "Utils/CommonFunctions";

class ConverterSettingsStore {
    settings;
    smrConverterStatus;
    deloConverterStatus;
    settingsLoading;
    freeSpaceStatus;

    constructor() {
        makeObservable(this, {
            settings: observable,
            smrConverterStatus: observable,
            deloConverterStatus: observable,
            settingsLoading: observable,
            freeSpaceStatus: observable
        });
        this.settings = {
            servicePath: '',
            deloConvert: true
        };
        this.smrConverterStatus = {
            isActive: false,
            hasError: false,
            status: ''
        };
        this.deloConverterStatus = {
            isActive: false,
            hasError: false,
            status: ''
        };
        this.settingsLoading = false;
        this.freeSpaceStatus = 0;
    }

    GetSettings = action(() => {
        if (this.settingsLoading)
            return;

        this.settingsLoading = true;

        SettingsRequests.GetConverterSettings()
            .then(action((values) => {
                this.settings.servicePath = (values.serviceUrl == null) ? '' : values.serviceUrl;
                this.settings.deloConvert = values.deloConvert;
            }))
            .finally(action(() => this.settingsLoading = false));
    });

    SetConverterState = action((state) => {
        this.smrConverterStatus.isActive = state.isActive;
        this.smrConverterStatus.hasError = state.hasError;
        this.smrConverterStatus.status = state.status;
    });

    SetDeloConverterState = action((state) => {
        this.deloConverterStatus.isActive = state.isActive;
        this.deloConverterStatus.hasError = state.hasError;
        this.deloConverterStatus.status = state.status;
    });

    SetFileStorageState = action((status) => {
        this.freeSpaceStatus = status;
    });

    SaveSettings = action(() => {
        if (this.settingsLoading)
            return;

        this.settingsLoading = true;

        SettingsRequests.SaveConverterSettings({ serviceUrl: this.settings.servicePath, deloConvert: this.settings.deloConvert })
            .then(action(values => {
                if (!values.error) {
                    ShowAlert('success', 'Настройки успешно сохранены.');
                }
                else {
                    ShowAlert('error',
                        <div>
                            При сохранении настроек произошла ошибка.<br />
                            {(values.error.errorText ? values.error.errorText : 'Убедитесь что СМР работает и повторите попытку.')}
                        </div>
                    );
                }
            }))
            .finally(action(() => this.settingsLoading = false));
    });

    SetConverterSetting = action((key, value) => {
        switch (key) {
            case 'servicePath':
                this.settings.servicePath = value;
                break;
            case 'deloConvert':
                this.settings.deloConvert = value;
                break;
        }
    });
}

export default new ConverterSettingsStore();